import { RestSlice } from '../../../../../redux/rest.slice';
import { CccDevice } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const cccDeviceSlice = new RestSlice<CccDevice>(
	localizationService.getLocalizedString('cccDevice.devices'),
	Resource.CccDevice
);
export default cccDeviceSlice.rests.reducer;
